module.exports = __webpack_public_path__ + "img/banner.f528fd58.png";